// extracted by mini-css-extract-plugin
export default {"nav-items":"page-nav__nav-items___PtL3","nav-item":"page-nav__nav-item__nsMOP","nav-link":"page-nav__nav-link__eBOBQ"};